import Flickity from 'flickity';

const announcements = {};

const announcementInit = ($carousel, index) => {
  if ($carousel.children().length < 2) {
    // Don't init pointless carousels with 1 or no slides
    return;
  }

  const id = $carousel.parent().attr('id');

  announcements[id] = new Flickity($carousel[0], {
    initialIndex: index ? index : 0,
    prevNextButtons: $carousel.data('prevNextButtons'),
    autoPlay: $carousel.data('autoPlay'),
    dragThreshold: window.theme.flickity.dragThreshold,
    pageDots: false,
    draggable: true,
    wrapAround: true,
    pauseAutoPlayOnHover: true,
    setGallerySize: false,
  });
};

export {
  announcements,
  announcementInit,
};